import { render, staticRenderFns } from "./localworthyDetail.vue?vue&type=template&id=772023ed&scoped=true&"
import script from "./localworthyDetail.vue?vue&type=script&lang=js&"
export * from "./localworthyDetail.vue?vue&type=script&lang=js&"
import style0 from "./localworthyDetail.vue?vue&type=style&index=0&id=772023ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772023ed",
  null
  
)

export default component.exports